import {FC, useEffect, useState} from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import Select from 'react-select'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../../components/UI'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {MasterModel} from '../../../modules/models'
import {getMasterModuleService} from '../../../modules/services/getModuleTypes.service'
import {RoomModel} from '../../../room/models'
import {getRoomsService} from '../../../room/services'
import {getBedByIdService} from '../../services/getBedById.service'

const FormEditBed: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [, setRooms] = useState<RoomModel[] | any>([])
  const [bedTypes, setBedTypes] = useState<MasterModel[] | any>([])
  const [statusBed, setStatusBed] = useState<MasterModel[] | any>([])
  const [subStatusBed, setSubStatusBed] = useState<MasterModel[] | any>([])
  const [bedSize, setBedSizes] = useState<MasterModel[] | any>([])
  const [camaCaliente] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [loading, setLoading] = useState(false)

  // const newBedSchema = Yup.object().shape({
  //   HabitacionId: Yup.string().required(),
  //   Codigo: Yup.string().required(),
  //   Descripcion: Yup.string().required(),
  //   TipoCamaId: Yup.string().required(),
  //   EstadoCamaId: Yup.string().required(),
  //   SubEstadoCamaId: Yup.string().required(),
  //   MedidaCamaId: Yup.string().required(),
  //   Observaciones: Yup.string().required(),
  // })

  const {
    register,
    formState: {errors},
    control,
    setValue,
  } = useFormContext()

  useEffect(() => {
    getBedById()
  }, [currentTabItem])

  const getBedById = async () => {
    setLoading(true)
    const {idToEdit} = currentTabItem
    if (idToEdit) {
      const {
        data: {data},
      } = await getBedByIdService(idToEdit as any)
      const {
        HabitacionId,
        Codigo,
        Descripcion,
        TipoCamaId,
        EstadoCamaId,
        SubEstadoCamaId,
        MedidaCamaId,
        CamaCaliente,
        Observaciones,
      } = data
      setValue('Id', idToEdit)
      setValue('HabitacionId', HabitacionId)
      setValue('Descripcion', Descripcion)
      setValue('TipoCamaId', TipoCamaId)
      setValue('EstadoCamaId', EstadoCamaId)
      setValue('Codigo', Codigo)
      setValue('SubEstadoCamaId', SubEstadoCamaId)
      setValue('MedidaCamaId', MedidaCamaId)
      setValue('CamaCaliente', CamaCaliente)
      setValue('Observaciones', Observaciones)
    }
    setLoading(false)
  }

  // const handleList = () => {
  //   const obj: TabModel = {
  //     ...currentTabItem,
  //     showPanel: false,
  //     content: {
  //       headerPanel: 'table-rooms',
  //     },
  //   }
  //   changeCurrentTabItem(obj)
  // }

  const getRooms = async () => {
    const {data: response} = await getRoomsService({pageNumber: 1, size: 1000})
    const mappedRooms = response?.data?.map((item) => ({value: item.Id, label: item.Codigo}))
    setRooms(mappedRooms)
  }

  const getBedTypes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'TipoCama',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setBedTypes(mappedMaster)
  }

  const getStatusBed = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'EstadoCama',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setStatusBed(mappedMaster)
  }

  const getSubStatusBed = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'SubEstadoCama',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setSubStatusBed(mappedMaster)
  }

  const getBedSizes = async () => {
    const response = await getMasterModuleService({
      pageNumber: 1,
      size: 100,
      tableName: 'MedidaCama',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setBedSizes(mappedMaster)
  }

  useEffect(() => {
    getRooms()
    getBedTypes()
    getStatusBed()
    getSubStatusBed()
    getBedSizes()
  }, [])

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <div className='d-flex row'>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              {/* <div className='mb-2 col-10'>
                  <label className='required form-label'>Habitaciones</label>
                  <div className='input-group input-group-sm'>
                    <Controller
                      control={control}
                      name='HabitacionId'
                      render={({field}) => (
                        <Select
                          {...field}
                          className='w-100'
                          options={rooms}
                          placeholder='Selecciona una habitacion'
                          value={rooms?.find((c: {value: string}) => c.value === field.value)}
                          onChange={(val) => field.onChange(val ? val.value : '')}
                        />
                      )}
                    />
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.HabitacionId?.message?.toString()}
                    </p>
                  </div>
                </div> */}
              <div className='mb-2 col-10'>
                <label className='required form-label'>Codigo de Cama</label>
                <div className='input-group input-group-sm'>
                  <input type='text' className='form-control' {...register('Codigo')} />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.Codigo?.message?.toString()}
                </p>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Descripcion de Cama</label>
                <div className='input-group input-group-sm'>
                  <input type='text' className='form-control' {...register('Descripcion')} />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.Descripcion?.message?.toString()}
                </p>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Tipo de Cama</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoCamaId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={bedTypes}
                        placeholder='Selecciona un tipo de cama'
                        value={bedTypes?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoCamaId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Estado de Cama</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='EstadoCamaId'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={statusBed}
                        placeholder='Selecciona un estado'
                        value={statusBed?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.EstadoCamaId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Sub estado de Cama</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='SubEstadoCamaId'
                    render={({field}) => (
                      <Select
                        {...field}
                        className='w-100'
                        key={field.value}
                        options={subStatusBed}
                        placeholder='Selecciona un sub estado'
                        value={subStatusBed?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.SubEstadoCamaId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Medida de Cama</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='MedidaCamaId'
                    render={({field}) => (
                      <Select
                        {...field}
                        className='w-100'
                        key={field.value}
                        options={bedSize}
                        placeholder='Selecciona un sub estado'
                        value={bedSize?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.MedidaCamaId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6 col-lg-3'>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Cama Caliente</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='CamaCaliente'
                    render={({field}) => (
                      <Select
                        {...field}
                        key={field.value}
                        className='w-100'
                        options={camaCaliente}
                        placeholder='Selecciona un sub estado'
                        value={camaCaliente?.find((c: {value: boolean}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.CamaCaliente?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='mb-2 col-10'>
                <label className='required form-label'>Observaciones</label>
                <div className='input-group input-group-sm'>
                  <input type='text' className='form-control' {...register('Observaciones')} />
                </div>
                <p
                  style={{
                    marginBottom: '0',
                    fontSize: '10px',
                    fontWeight: '600',
                    color: 'red',
                    marginLeft: '5px',
                  }}
                >
                  {errors.Observaciones?.message?.toString()}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-center mb-3'>
          {/* <button type='submit' className='btn btn-primary'>
              Guardar
            </button> */}
        </div>
        {loading ? <KTableLoading title='Cargando...' /> : null}

        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </KTCard>
    </>
  )
}

export {FormEditBed}
